import { https , httpsFile } from './http.js' ;

export function index () {
    return https().get( `/permission` )
}
export function datatable(page,currentpage){
    return httpsFile().get(`/permissions-table?page=${page}&currentpage=${currentpage}` )
}

export function create ( permission ) {
    return httpsFile().post( '/permission' , permission )
}

export function edit ( permission ) {
    return https().get( `/permission/${permission}/edit` )
}

export function update ( id, permission ) {
    return httpsFile().post( `/permission/${id}` , permission )
}

export function destroy ( permission ) {
    return httpsFile().delete( `/permission/${permission}` )
}